import React, { useEffect, useRef, useState } from 'react';
import HeaderUser from '../components/homePage/HeaderUser';
import FooterPage from '../components/homePage/FooterPage';
import { Link } from 'react-router-dom';
import Cookies from "js-cookie";
import SettingsSidebar from '../components/settings/SettingsSidebar';

// Renamed function component to UserSettings for better convention
function UserSettings() {
  // Safely parse token and handle potential errors or missing cookie
  const tokenCookie = Cookies.get("authTokenUserLogin");
  const token = tokenCookie ? JSON.parse(decodeURIComponent(tokenCookie)) : null;

  // useState for form data and settings
  const [formData, setFormData] = useState({ name_show: '2' });
  const [notificationSetting, setNotificationSetting] = useState({});
  const [phoneSetting, setPhoneSetting] = useState({});
  const [profileInformation, setProfileInformation] = useState({});
  const [hideProfile, setHideProfile] = useState({});
  const [profileDetails, setProfileDetails] = useState({});


  // 1. State for controlling the modal's visibility
  const [isModalOpen, setIsModalOpen] = useState(false);

  // 2. State for the form logic
  const [mobileNumber, setMobileNumber] = useState('');
  const [otp, setOtp] = useState(['', '', '', '']);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [message, setMessage] = useState('');

  // --- Modal Control Functions ---
  const openModal = () => {
    // Reset state upon opening
    setMobileNumber('');
    setOtp(['', '', '', '']);
    setIsOtpSent(false);
    setMessage('');
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // --- Form Handlers ---
  const handleMobileChange = (e) => {
    setMobileNumber(e.target.value.replace(/[^0-9]/g, '').slice(0, 10)); // Restrict to 10 digits
  };

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (value.length > 1 || isNaN(parseInt(value)) && value !== '') return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1); // Take only the last character entered
    setOtp(newOtp);

    // Auto-focus on the next input
    if (value && index < 3) {
      const nextInput = document.getElementById(`otp-input-pure-${index + 1}`);
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  // Auto-backspace handling (optional but good UX)
  const handleOtpKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-input-pure-${index - 1}`);
      if (prevInput) {
        prevInput.focus();
      }
    }
  };

  // --- API Simulations ---
  const handleSendOtp = (e) => {
    e.preventDefault(); // Prevent default link/form action

    if (!mobileNumber || mobileNumber.length < 10) {
      setMessage('Please enter a valid 10-digit mobile number.');
      return;
    }

    setMessage(`Sending OTP to ${mobileNumber}...`);
    // Simulate API call for sending OTP

    setTimeout(() => {
      setIsOtpSent(true);
      setMessage('OTP sent successfully. Check your phone.');
    }, 1500);
  };

  const handleSubmitOtp = async (e) => {
    e.preventDefault();

    const enteredOtp = otp.join("");

    // Validation
    if (enteredOtp.length !== 4) {
      setMessage("Please enter the 4-digit OTP.");
      return;
    }

    setMessage("Verifying OTP...");

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/change-contact-number`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // if using JWT
        },
        body: JSON.stringify({
          contact_no: mobileNumber,
          otp: enteredOtp,
        }),
      });

      const data = await response.json();

      if (data.status) {
        setMessage("OTP verified! Number updated successfully.");
        loadSettings();
        setTimeout(() => {
          closeModal();
          setOtp(["", "", "", ""]); // reset fields
        }, 1500);
      } else {
        setMessage(data.message || "Invalid OTP. Try again.");
      }
    } catch (error) {
      console.error(error);
      setMessage("Server error. Try again later.");
    }
  };


  // Use Tailwind or your existing CSS to manage the 'show' state
  const modalClasses = `modal loginpop ${isModalOpen ? 'show d-block' : 'd-none'}`;
  const backdropClasses = isModalOpen ? 'modal-backdrop fade show' : '';
  // const [loading, setLoading] = useState(false); // Uncomment if needed

  // --- API Utility Function ---
  const fetchAPI = async (url, method = "GET", body = null) => {
    if (!token) {
      console.error("Authentication token is missing.");
      // Handle redirect or error for missing token here if necessary
      return { status: false, message: "No token found" };
    }

    const res = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: body ? JSON.stringify(body) : null
    });

    // Check for non-200 responses before trying to parse JSON
    if (!res.ok) {
      console.error(`API Error: ${res.status} at ${url}`);
      return { status: false, message: `HTTP error: ${res.status}` };
    }

    return res.json();
  };

  // --- Load Settings ---
  const loadSettings = async () => {
    // setLoading(true);

    try {
      // Profile Details
      const profileDetails = await fetchAPI(`${process.env.REACT_APP_BASE_URL_API}/api/user/get-profile`);
      if (profileDetails.status) setProfileDetails(profileDetails.data || {});


      // Notification Setting
      const notificationRes = await fetchAPI(`${process.env.REACT_APP_BASE_URL_API}/api/user/get-notification-settings`);
      if (notificationRes.status) setNotificationSetting(notificationRes.data || {});

      // PHONE SETTING
      const phoneRes = await fetchAPI(`${process.env.REACT_APP_BASE_URL_API}/api/user/get-profile-phone-setting-list`);
      if (phoneRes.status) setPhoneSetting(phoneRes.data || {});

      // PROFILE INFORMATION
      const infoRes = await fetchAPI(`${process.env.REACT_APP_BASE_URL_API}/api/user/get-profile-information-setting-list`);
      if (infoRes.status) setProfileInformation(infoRes.data || {});

      // HIDE / DELETE PROFILE
      const hideRes = await fetchAPI(`${process.env.REACT_APP_BASE_URL_API}/api/user/get-profile-hide`);
      if (hideRes.status) setHideProfile(hideRes.data || {});



    } catch (error) {
      console.error("Error loading settings:", error);
    }

    // setLoading(false);
  };

  // --- Save Notification Setting---

  // --- Save Settings Functions ---
  const saveNotificationSetting = async (updatedPayload) => {
    const result = await fetchAPI(
      `${process.env.REACT_APP_BASE_URL_API}/api/user/save-notification-settings`,
      "POST",
      updatedPayload
    );
    console.log("Notification Setting Save Result:", result);

    return result;
  };

  // --- Save Settings Functions ---
  const savePhoneSetting = async () => {
    // Use phoneSetting state for the body
    const result = await fetchAPI(
      `${process.env.REACT_APP_BASE_URL_API}/api/user/save-profile-phone-setting`,
      "POST",
      phoneSetting
    );
    console.log("Phone Setting Save Result:", result);
    // Add success/error handling (e.g., toast notification) here
  };

  const saveProfileInformation = async () => {
    // Use profileInformation state for the body
    const result = await fetchAPI(
      `${process.env.REACT_APP_BASE_URL_API}/api/user/save-profile-information-setting`,
      "POST",
      profileInformation
    );
    console.log("Profile Info Save Result:", result);
    // Add success/error handling (e.g., toast notification) here
  };

  // --- Hide/Unhide/Delete Profile ---
  const updateHideProfile = async (type) => {
    if (!type) {
      console.error("Update Hide Profile requires a type ('hide' or 'delete')");
      return;
    }

    const action = (type === 'hide')
      ? (hideProfile.hide_profile === 1 ? 'unhide' : 'hide') // Toggle hide
      : 'delete'; // Always 'delete' for delete button

    const result = await fetchAPI(
      `${process.env.REACT_APP_BASE_URL_API}/api/user/save-profile-hide`,
      "POST",
      { action: action }
    );
    console.log("Hide/Delete Profile Result:", result);

    if (result.status) {
      // Reload the setting or update state locally based on action
      if (type === 'hide') {
        setHideProfile(prev => ({ ...prev, hide_profile: prev.hide_profile === 1 ? 2 : 1 }));
      }
      // Handle successful deletion (e.g., redirect/logout)
    }
  };



  // --- useEffect to Load Data on Component Mount ---
  useEffect(() => {
    if (token) {
      loadSettings();
    } else {
      console.warn("User not authenticated.");
      // Handle unauthenticated state (e.g., redirect to login)
    }
  }, [token]);


  // --- Render Content ---
  return (
    <>
      <HeaderUser />
      <>
        {/* Banner Section - inrbnr: Renamed to standard BEM-style for example */}
        <section className="inrbnr">
          <div className="container-fluid con-flu-padd">
            <div className="inrbnrContent">
              <h1>Settings </h1>
              <ul className="inrbrnNav">
                <li>
                  <Link to="/dashboard">
                    <img src="assets/img/icons/home.png" alt="home icon" />
                  </Link>
                  <img src="assets/img/icons/arrows.png" alt="arrows icons" />
                </li>

                <li>
                  <Link to="/settings">Settings</Link>
                </li>
              </ul>
            </div>
          </div>
        </section>
        {/* Section End */}
        <section>
          <div className="register-sec">
            <div className="container-fluid con-flu-padd">
              <div className="mx-2">
                <div className="row pb-20 pt-40">
                  <div className="col-md-3 p-0">
                    <SettingsSidebar />
                    <div className="img-settings">
                      <img src="assets/img/setting-group.png" alt="Settings Group" />
                    </div>
                  </div>
                  <div className="col-md-9 set-pad-lef">
                    <div className="heading-settings">
                      <h3>Settings</h3>
                    </div>
                    <section className="faqsSection">
                      <div className="accordion" id="accordionExampletwo">
                        {/* Notification Setting */}
                        {/* Notification Setting */}
                        <div className="accordion-items">
                          <h2 className="accordion-header" id="headingNotification">
                            <button
                              className="accordion-button collapsed"
                              style={{ backgroundColor: "#FFF9F0" }}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseNotification"
                              aria-expanded="false"
                              aria-controls="collapseNotification"
                            >
                              <img src="assets/img/check-alt_svgrepo.com.png" alt="Notification Icon" /> Notification Setting
                            </button>
                          </h2>
                          <div
                            id="collapseNotification"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingNotification"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              {/* Container for notification toggles - added a row for better structure */}
                              <div className="row">

                                {/* New Invitations */}
                                <div className="col-lg-6 col-12 mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <h6 style={{ fontSize: 14 }}>New Invitations</h6>
                                    <div>
                                      <div className="checkbox-wrapper-3">

                                        <input
                                          type="checkbox"
                                          id="cbx-invitations"
                                          checked={notificationSetting.new_invitation === 1}
                                          onChange={async () => {
                                            const isCurrentlyEnabled = notificationSetting.new_invitation === 1;
                                            const newValue = isCurrentlyEnabled ? 0 : 1;
                                            const updatedPayload = {
                                              ...notificationSetting,
                                              new_invitation: newValue
                                            };
                                            setNotificationSetting(updatedPayload);
                                            try {
                                              await saveNotificationSetting(updatedPayload);
                                            } catch (error) {
                                              setNotificationSetting(notificationSetting);
                                            }
                                          }}
                                          role="switch"
                                          aria-checked={notificationSetting.new_invitation === 1 ? 'true' : 'false'}
                                        />
                                        <label htmlFor="cbx-invitations" className="toggle">
                                          <span />
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* New Accepts */}
                                {/* col-lg-12 divider removed, using mb-3 for spacing or adding a new column for alignment */}
                                <div className="col-lg-6 col-12 mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <h6 style={{ fontSize: 14 }}>New Accepts</h6>
                                    <div>
                                      <div className="checkbox-wrapper-3">
                                        <input
                                          type="checkbox"
                                          id="cbx-accepts"
                                          checked={notificationSetting.new_accepts === 1}
                                          onChange={async () => {
                                            const isCurrentlyEnabled = notificationSetting.new_accepts === 1;
                                            const newValue = isCurrentlyEnabled ? 0 : 1;
                                            const updatedPayload = {
                                              ...notificationSetting,
                                              new_accepts: newValue
                                            };
                                            setNotificationSetting(updatedPayload);
                                            try {
                                              await saveNotificationSetting(updatedPayload);
                                            } catch (error) {
                                              setNotificationSetting(notificationSetting);
                                            }
                                          }}
                                          role="switch"
                                          aria-checked={notificationSetting.new_accepts === 1 ? 'true' : 'false'}
                                        />
                                        <label htmlFor="cbx-accepts" className="toggle">
                                          <span />
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* New Matches */}
                                <div className="col-lg-6 col-12 mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <h6 style={{ fontSize: 14 }}>New Matches</h6>
                                    <div>
                                      <div className="checkbox-wrapper-3">
                                        <input
                                          type="checkbox"
                                          id="cbx-matches"
                                          checked={notificationSetting.new_matches === 1}
                                          onChange={async () => {
                                            const isCurrentlyEnabled = notificationSetting.new_matches === 1;
                                            const newValue = isCurrentlyEnabled ? 0 : 1;
                                            const updatedPayload = {
                                              ...notificationSetting,
                                              new_matches: newValue
                                            };
                                            setNotificationSetting(updatedPayload);
                                            try {
                                              await saveNotificationSetting(updatedPayload);
                                            } catch (error) {
                                              setNotificationSetting(notificationSetting);
                                            }
                                          }}
                                          role="switch"
                                          aria-checked={notificationSetting.new_matches === 1 ? 'true' : 'false'}
                                        />
                                        <label htmlFor="cbx-matches" className="toggle">
                                          <span />
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* New Offers */}
                                <div className="col-lg-6 col-12 mb-3">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <h6 style={{ fontSize: 14 }}>New Offers</h6>
                                    <div>
                                      <div className="checkbox-wrapper-3">
                                        <input
                                          type="checkbox"
                                          id="cbx-offers"
                                          checked={notificationSetting.new_offers === 1}
                                          onChange={async () => {
                                            const isCurrentlyEnabled = notificationSetting.new_offers === 1;
                                            const newValue = isCurrentlyEnabled ? 0 : 1;
                                            const updatedPayload = {
                                              ...notificationSetting,
                                              new_offers: newValue
                                            };
                                            setNotificationSetting(updatedPayload);
                                            try {
                                              await saveNotificationSetting(updatedPayload);
                                            } catch (error) {
                                              setNotificationSetting(notificationSetting);
                                            }
                                          }}
                                          role="switch"
                                          aria-checked={notificationSetting.new_offers === 1 ? 'true' : 'false'}
                                        />
                                        <label htmlFor="cbx-offers" className="toggle">
                                          <span />
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                              {/* End of row */}
                            </div>
                          </div>
                        </div>


                        {/* --- Phone Setting Accordion --- */}
                        <div className="accordion-items">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              style={{ backgroundColor: "#FFF9F0" }}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsewhys2"
                              aria-expanded="false"
                              aria-controls="collapsewhys2"
                            >
                              <img
                                src="assets/img/check-alt_svgrepo.com.png"
                                alt=""
                              />{" "}
                              Phone Setting
                            </button>
                          </h2>
                          <div
                            id="collapsewhys2"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordionExampletwo" // Corrected parent ID
                          >
                            <div className="accordion-body">
                              <div className="d-flex align-items-start justify-content-between">
                                <div className="phonesetting d-flex align-items-center justify-content-between gap-3">
                                  <img src="assets/img/mobile-setting.png" alt='Mobile Setting' />
                                  <div>
                                    <span>Phone No. is Verified:</span>
                                    {/* Assuming phone number comes from state or is hardcoded for design */}
                                    +91-{profileDetails.contact_no}
                                  </div>
                                </div>
                                <div>
                                  <Link to="#" onClick={openModal}>Edit</Link>
                                </div>
                              </div>
                              <h6 className="mt-4">Phone Privacy Setting</h6>
                              <div className="radio-wrapper-31 mt-3">
                                <label htmlFor="phone-setting-1">
                                  <input
                                    type="radio"
                                    id="phone-setting-1"
                                    checked={phoneSetting.view_type === 1}
                                    onChange={() => setPhoneSetting({ ...phoneSetting, view_type: 1 })}
                                  />
                                  <span className="label" />
                                  Only Premium Members
                                </label>
                              </div>
                              <div className="radio-wrapper-31 mt-3">
                                <label htmlFor="phone-setting-2">
                                  <input
                                    type="radio"
                                    id="phone-setting-2"
                                    checked={phoneSetting.view_type === 2}
                                    onChange={() => setPhoneSetting({ ...phoneSetting, view_type: 2 })}
                                  />
                                  <span className="label" />
                                  Only Premium Members You Like
                                </label>
                              </div>
                              <div className="radio-wrapper-31 mt-3 mb-5">
                                <label htmlFor="phone-setting-3">
                                  <input
                                    type="radio"
                                    id="phone-setting-3"
                                    checked={phoneSetting.view_type === 3}
                                    onChange={() => setPhoneSetting({ ...phoneSetting, view_type: 3 })}
                                  />
                                  <span className="label" />
                                  No one (Matches won't be able to call you)
                                </label>
                              </div>
                              <div className="col-12 col-lg-6 text-end">
                                <Link
                                  to="#"
                                  className="button homeform-btn d-inline px-4 py-2 mt-5"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    savePhoneSetting();
                                  }}
                                  data-bs-toggle="collapse" data-bs-target="#collapsewhys2" aria-expanded="false" aria-controls="collapsewhys2"
                                >
                                  Submit{" "}
                                  <i className="fa-solid fa-arrow-right-long" />{" "}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* --- Profile Information Accordion --- */}
                        <div className="accordion-items">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              style={{ backgroundColor: "#FFF9F0" }}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsewhys1"
                              aria-expanded="false"
                              aria-controls="collapsewhys1"
                            >
                              <img
                                src="assets/img/check-alt_svgrepo.com.png"
                                alt=""
                              />{" "}
                              Profile Information
                            </button>
                          </h2>
                          <div
                            id="collapsewhys1"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordionExampletwo" // Corrected parent ID
                          >
                            <div className="accordion-body">
                              <div className="row">
                                {/* My Name */}
                                <div className="col-lg-7 pb-3">
                                  <h6 className="mb-2">My Name:</h6>
                                  <div className="radio-wrapper-19">
                                    <div className="radio-inputs-19">
                                      {/* Visible to all: 1 */}
                                      <label htmlFor="myname-1">
                                        <input
                                          type="radio"
                                          id="myname-1"
                                          checked={profileInformation.name_show === 1}
                                          onChange={() => setProfileInformation({ ...profileInformation, name_show: 1 })}
                                        />
                                        <span className="name">Visible to all</span>
                                      </label>
                                      {/* Only premium members: 2 */}
                                      <label htmlFor="myname-2">
                                        <input
                                          type="radio"
                                          id="myname-2"
                                          checked={profileInformation.name_show === 2}
                                          onChange={() => setProfileInformation({ ...profileInformation, name_show: 2 })}
                                        />
                                        <span className="name">Only premium members</span>
                                      </label>
                                      {/* Hide: 3 */}
                                      <label htmlFor="myname-3">
                                        <input
                                          type="radio"
                                          id="myname-3"
                                          checked={profileInformation.name_show === 3}
                                          onChange={() => setProfileInformation({ ...profileInformation, name_show: 3 })}
                                        />
                                        <span className="name">Hide</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                {/* Email ID: 1=Hide, 2=Visible (Corrected Logic) */}
                                <div className="col-lg-5 pb-3">
                                  <h6 className="mb-2">Email ID:</h6>
                                  <div className="radio-wrapper-19">
                                    <div className="radio-inputs-19">
                                      {/* Visible: 2 */}
                                      <label htmlFor="email-2">
                                        <input
                                          type="radio"
                                          id="email-2"
                                          checked={profileInformation.email_show === 2}
                                          onChange={() => setProfileInformation({ ...profileInformation, email_show: 2 })}
                                        />
                                        <span className="name">Visible</span>
                                      </label>
                                      {/* Hide: 1 */}
                                      <label htmlFor="email-1">
                                        <input
                                          type="radio"
                                          id="email-1"
                                          checked={profileInformation.email_show === 1}
                                          onChange={() => setProfileInformation({ ...profileInformation, email_show: 1 })}
                                        />
                                        <span className="name">Hide</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                {/* Customer ID: 1=Hide, 2=Visible (Corrected Logic) */}
                                <div className="col-lg-3 pb-3">
                                  <h6 className="mb-2">Customer ID:</h6>
                                  <div className="radio-wrapper-19">
                                    <div className="radio-inputs-19">
                                      {/* Visible: 2 */}
                                      <label htmlFor="custmid-2">
                                        <input
                                          type="radio"
                                          id="custmid-2"
                                          checked={profileInformation.customer_id_show === 2}
                                          onChange={() => setProfileInformation({ ...profileInformation, customer_id_show: 2 })}
                                        />
                                        <span className="name">Visible</span>
                                      </label>
                                      {/* Hide: 1 */}
                                      <label htmlFor="custmid-1">
                                        <input
                                          type="radio"
                                          id="custmid-1"
                                          checked={profileInformation.customer_id_show === 1}
                                          onChange={() => setProfileInformation({ ...profileInformation, customer_id_show: 1 })}
                                        />
                                        <span className="name">Hide</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                {/* My Photo: 1=Visible by request, 2=Visible (Corrected Logic) */}
                                <div className="col-lg-4 pb-3">
                                  <h6 className="mb-2">My Photo:</h6>
                                  <div className="radio-wrapper-19">
                                    <div className="radio-inputs-19">
                                      {/* Visible: 2 */}
                                      <label htmlFor="myphoto-2">
                                        <input
                                          type="radio"
                                          id="myphoto-2"
                                          checked={profileInformation.photo_show === 2}
                                          onChange={() => setProfileInformation({ ...profileInformation, photo_show: 2 })}
                                        />
                                        <span className="name">Visible</span>
                                      </label>
                                      {/* Visible by request: 1 */}
                                      <label htmlFor="myphoto-1">
                                        <input
                                          type="radio"
                                          id="myphoto-1"
                                          checked={profileInformation.photo_show === 1}
                                          onChange={() => setProfileInformation({ ...profileInformation, photo_show: 1 })}
                                        />
                                        <span className="name">
                                          Visible by request
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                {/* Date of Birth: 1=Visible by request, 2=Visible (Corrected Logic) */}
                                <div className="col-lg-4 pb-3">
                                  <h6 className="mb-2">Date of Birth:</h6>
                                  <div className="radio-wrapper-19">
                                    <div className="radio-inputs-19">
                                      {/* Visible: 2 */}
                                      <label htmlFor="dob-2">
                                        <input
                                          type="radio"
                                          id="dob-2"
                                          checked={profileInformation.date_of_birth_show === 2}
                                          onChange={() => setProfileInformation({ ...profileInformation, date_of_birth_show: 2 })}
                                        />
                                        <span className="name">Visible</span>
                                      </label>
                                      {/* Visible by request: 1 */}
                                      <label htmlFor="dob-1">
                                        <input
                                          type="radio"
                                          id="dob-1"
                                          checked={profileInformation.date_of_birth_show === 1}
                                          onChange={() => setProfileInformation({ ...profileInformation, date_of_birth_show: 1 })}
                                        />
                                        <span className="name">
                                          Visible by request
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                {/* Work With: 1=Hide, 2=Visible (Corrected Logic) */}
                                <div className="col-lg-3 pb-3">
                                  <h6 className="mb-2">Work With:</h6>
                                  <div className="radio-wrapper-19">
                                    <div className="radio-inputs-19">
                                      {/* Visible: 2 */}
                                      <label htmlFor="workwith-2">
                                        <input
                                          type="radio"
                                          id="workwith-2"
                                          checked={profileInformation.work_with_show === 2}
                                          onChange={() => setProfileInformation({ ...profileInformation, work_with_show: 2 })}
                                        />
                                        <span className="name">Visible</span>
                                      </label>
                                      {/* Hide: 1 */}
                                      <label htmlFor="workwith-1">
                                        <input
                                          type="radio"
                                          id="workwith-1"
                                          checked={profileInformation.work_with_show === 1}
                                          onChange={() => setProfileInformation({ ...profileInformation, work_with_show: 1 })}
                                        />
                                        <span className="name">Hide</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                {/* Income: 1=Hide, 2=Visible (Corrected Logic) */}
                                <div className="col-lg-3 pb-3">
                                  <h6 className="mb-2">Income:</h6>
                                  <div className="radio-wrapper-19">
                                    <div className="radio-inputs-19">
                                      {/* Visible: 2 */}
                                      <label htmlFor="income-2">
                                        <input
                                          type="radio"
                                          id="income-2"
                                          checked={profileInformation.income_show === 2}
                                          onChange={() => setProfileInformation({ ...profileInformation, income_show: 2 })}
                                        />
                                        <span className="name">Visible</span>
                                      </label>
                                      {/* Hide: 1 */}
                                      <label htmlFor="income-1">
                                        <input
                                          type="radio"
                                          id="income-1"
                                          checked={profileInformation.income_show === 1}
                                          onChange={() => setProfileInformation({ ...profileInformation, income_show: 1 })}
                                        />
                                        <span className="name">Hide</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                <div className='col-12 text-end'>
                                  <Link
                                    to="#"
                                    className="button homeform-btn d-inline px-4 py-2 mt-3"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      saveProfileInformation();
                                    }}
                                    data-bs-toggle="collapse" data-bs-target="#collapsewhys1" aria-expanded="true" aria-controls="collapsewhys1"
                                  >
                                    Submit{" "}
                                    <i className="fa-solid fa-arrow-right-long" />{" "}
                                  </Link>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>

                        {/* --- Hide / Delete Profile Accordion --- */}
                        <div className="accordion-items">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              style={{ backgroundColor: "#FFF9F0" }}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsewhys4"
                              aria-expanded="false"
                              aria-controls="collapsewhys4"
                            >
                              <img
                                src="assets/img/check-alt_svgrepo.com.png"
                                alt=""
                              />
                              Hide / Delete Profile
                            </button>
                          </h2>
                          <div
                            id="collapsewhys4"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordionExampletwo" // Corrected parent ID
                          >
                            <div className="accordion-body">
                              <div className="row">
                                {/* Hide Profile */}
                                <div className="col-lg-6">
                                  <div className="hideprof-box d-sm-flex align-items-start justify-content-sm-between">
                                    <div>
                                      <h5>Hide Profile</h5>
                                      <h6>Your profile is currently {hideProfile.hide_profile === 1 ? "**Hidden**" : "**Visible**"}</h6>
                                      <p>
                                        When you hide your profile, you will not be
                                        visible on Vivashri.com. you will neither be
                                        able to contact anyone.
                                      </p>
                                    </div>
                                    <Link
                                      to="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        // Pass 'hide' as type
                                        updateHideProfile('hide');
                                      }}
                                    >
                                      {/* Logic: 1 = Hidden, so button says "Unhide" */}
                                      {hideProfile.hide_profile === 1 ? "Unhide" : "Hide"}
                                    </Link>
                                  </div>
                                </div>
                                {/* Delete Profile */}
                                <div className="col-lg-6">
                                  <div className="hideprof-box d-sm-flex align-items-start justify-content-sm-between">
                                    <div>
                                      <h5>Delete Profile</h5>
                                      <h6>Delete your Profile from Vivashri.com</h6>
                                      <p>
                                        You will be permanently lose all profile
                                        information, match interactions and paid
                                        membership.
                                      </p>
                                    </div>
                                    <Link
                                      to="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        // Pass 'delete' as type
                                        if (window.confirm("Are you sure you want to permanently delete your profile?")) {
                                          updateHideProfile('delete');
                                        }
                                      }}
                                    >
                                      Delete
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* model */}
        <div
          className={modalClasses}
          id="loginModal2"
          tabIndex={-1}
          role="dialog" // Add ARIA role for accessibility
          aria-labelledby="exampleModalLabel"
          aria-hidden={!isModalOpen}
          // Inline style to ensure it appears above content when active
          style={{ display: isModalOpen ? 'block' : 'none' }}
        >
          <div className="modal-dialog">
            <div className="modal-content position-relative">
              {/* Close Button */}
              <button
                type="button"
                className="btn-close"
                onClick={closeModal}
                aria-label="Close"
              />
              <div className="modal-body">
                <h5>Edit Phone Number</h5>
                <div className="otp-login">

                  {/* Status Message */}
                  {message && (
                    <p className={`text-center py-2 ${message.includes('success') ? 'text-success' : 'text-danger'}`}>
                      {message}
                    </p>
                  )}

                  {/* Mobile Number Input */}
                  <div className="loginformrow">
                    <label htmlFor="mobileInput">
                      Enter Mobile No. <span className="red">*</span>
                    </label>
                    <input
                      type="tel"
                      id="mobileInput"
                      placeholder="Mobile No."
                      className="form-control"
                      value={mobileNumber}
                      onChange={handleMobileChange}
                      disabled={isOtpSent} // Disable input after OTP is sent
                      maxLength={10}
                    />
                    <div className="d-flex align-items-center justify-content-between mt-2">
                      <span className="otpnot">We will send you an OTP to login</span>
                      <div className="text-end">
                        {/* Send OTP Button */}
                        <Link
                          to="#"
                          className={`sendotp ${isOtpSent ? 'text-muted' : ''}`}
                          onClick={!isOtpSent ? handleSendOtp : handleSendOtp} // Can reuse for resend
                          style={{ pointerEvents: isOtpSent ? 'none' : 'auto' }}
                        >
                          {isOtpSent ? 'Resend OTP' : 'Send OTP'}
                        </Link>
                      </div>
                    </div>
                  </div>

                  {/* OTP Input Boxes - Conditionally Rendered */}
                  {isOtpSent && (
                    <>
                      <div className="loginformrow mt-3">
                        <label className="mt-0" htmlFor="otpBoxInput">
                          OTP <span className="red">*</span>
                        </label>
                        <div className="otp-boxes d-flex justify-content-between">
                          {otp.map((digit, index) => (
                            <input
                              key={index}
                              type="number"
                              id={`otp-input-pure-${index}`}
                              maxLength={1}
                              className="otp-input form-control text-center"
                              value={digit}
                              onChange={(e) => handleOtpChange(e, index)}
                              onKeyDown={(e) => handleOtpKeyDown(e, index)}
                              autoFocus={index === 0}
                            />
                          ))}
                        </div>
                      </div>

                      {/* Submit OTP Button */}
                      <div className="loginformrow pt-2">
                        <Link
                          to="#"
                          className="button login-btn d-block text-center"
                          onClick={handleSubmitOtp}
                        >
                          Submit OTP
                        </Link>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Manual Backdrop - Only render when modal is open */}
        {isModalOpen && (
          <div className={backdropClasses} onClick={closeModal}></div>
        )}

        {/* model end */}
      </>
      <FooterPage />
    </>
  )
}

// Export the renamed component
export default UserSettings;